import {Filenka, L, M, Micro, S} from "./svg/Types";

export const garageInfo = [
  {
    id: 0,
    name: "S-гофр",
    svg: <S />,
    img: "./imgs/gofry/S.png",
    types: [
      {
        name: "Стандартные",
        colors: [...getStandartColorMany("S")],
      },
      {
        name: "Под дерево",
        colors: [...getWoodColorsMini("S")],
      },
      {
        name: "Текстурная цифровая печать",
        colors: [...getTextureCifrovayaPechat("S")],
      },
    ],
  },
  {
    id: 1,
    name: "M-гофр",
    svg: <M />,
    img: "./imgs/gofry/M.png",
    types: [
      {
        name: "Стандартные",
        colors: [
          {
            name: "Белый",
            imgL: "./imgs/gofry/M.png",
            color: "rgb(241, 240, 234)",
            backgroundPreview: "rgb(241, 240, 234)",
          },
          {
            name: "Серый антрацит",
            imgL: "./imgs/M/RAL7016.jpg",
            color: "",
            backgroundPreview: "rgb(56, 62, 66)",
          },
          {
            name: "Коричневый",
            imgL: "./imgs/M/RAL8014.jpg",
            color: "",
            backgroundPreview: "rgb(74, 53, 38)",
          },
          {
            name: "Графит",
            imgL: "./imgs/M/704.jpg",
            color: "",
            backgroundPreview: "rgb(20, 24, 27)",
          },
        ],
      },
      {
        name: "Под дерево",
        colors: [
          {
            name: "Золотой дуб",
            imgL: './imgs/M/gouk.jpg"',
            color: "",
            backgroundPreview: 'url("./imgs/preview/gouk_preview.jpg")',
          },
          {
            name: "Темный дуб",
            imgL: "./imgs/M/douk.jpg",
            color: "",
            backgroundPreview: 'url("./imgs/preview/douk_preview.jpg")',
          },
          {
            name: "Вишня",
            imgL: "./imgs/M/ch.jpg",
            color: "",
            backgroundPreview: 'url("./imgs/preview/ch_preview.jpg")',
          },
        ],
      },
      {
        name: "Текстурная цифровая печать",
        colors: [...getTextureCifrovayaPechat("M")],
      },
    ],
  },
  {
    id: 2,
    name: "L-гофр",
    svg: <L />,
    img: "./imgs/gofry/L.png",
    types: [
      {
        name: "Стандартные",
        colors: [...getStandartColorsMini("L")],
      },
      {
        name: "Под дерево",
        colors: [...getWoodColorsMini("L")],
      },
      {
        name: "Текстурная цифровая печать",
        colors: [...getTextureCifrovayaPechat("L")],
      },
    ],
  },
  {
    id: 3,
    name: "Микроволна",
    svg: <Micro />,
    img: "./imgs/gofry/MW.png",
    types: [
      {
        name: "Стандартные",
        colors: [...getStandartColorMany("MW")],
      },
      {
        name: "Текстурная цифровая печать",
        colors: [...getTextureCifrovayaPechat("MW")],
      },
    ],
  },
  {
    id: 4,
    name: "Филенка",
    svg: <Filenka />,
    img: "./imgs/gofry/F.png",
    types: [
      {
        name: "Стандартные",
        colors: [
          {
            name: "Белый",
            imgL: `./imgs/gofry/F.png`,
            color: "rgb(241, 240, 234)",
            backgroundPreview: "rgb(241, 240, 234)",
          },
          {
            name: "Коричневый",
            imgL: `./imgs/F/RAL8014.jpg`,
            color: "",
            backgroundPreview: "rgb(74, 53, 38)",
          },
        ],
      },
      {
        name: "Под дерево",
        colors: [
          {
            name: "Золотой дуб",
            imgL: `./imgs/F/gouk.jpg`,
            color: "",
            backgroundPreview: 'url("./imgs/preview/gouk_preview.jpg")',
          },
          {
            name: "Темный дуб",
            imgL: `./imgs/F/douk.jpg`,
            color: "",
            backgroundPreview: 'url("./imgs/preview/douk_preview.jpg")',
          },
        ],
      },
      {
        name: "Текстурная цифровая печать",
        colors: [...getTextureCifrovayaPechat("F")],
      },
    ],
  },
];


function getStandartColorsMini(name) {
    return [
        {
            name: 'Белый',
            imgL: `./imgs/gofry/${name}.png`,
            color: 'rgb(241, 240, 234)',
            backgroundPreview: 'rgb(241, 240, 234)',
        },
        {
            name: 'Серый антрацит',
            imgL: `./imgs/${name}/RAL7016.jpg`,
            color: '',
            backgroundPreview: 'rgb(56, 62, 66)',
        },
        {
            name: 'Коричневый',
            imgL: `./imgs/${name}/RAL8014.jpg`,
            color: '',
            backgroundPreview: 'rgb(74, 53, 38)',
        },
        {
            name: 'Графит',
            imgL: `./imgs/${name}/704.jpg`,
            color: '',
            backgroundPreview: 'rgb(20, 24, 27)',
        }
    ]
}

function getWoodColorsMini(name) {
    return [
        {
            name: 'Золотой дуб',
            imgL: `./imgs/${name}/gouk.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/gouk_preview.jpg")',
        },
        {
            name: 'Темный дуб',
            imgL: `./imgs/${name}/douk.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/douk_preview.jpg")',
        },
        {
            name: 'Вишня',
            imgL: `./imgs/${name}/ch.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/ch_preview.jpg")',
        },
    ]
}

//

function getStandartColorMany(name) {
    return [
        {
            name: 'Белый',
            imgL: `./imgs/gofry/${name}.png`,
            color: 'rgb(241, 240, 234)',
            backgroundPreview: 'rgb(241, 240, 234)',
        },
        {
            name: 'Слоновая кость',
            imgL: `./imgs/gofry/${name}.png`,
            color: 'rgb(230, 210, 181)',
            backgroundPreview: 'rgb(230, 210, 181)',
        },
        {
            name: 'Пурпурно-красный',
            imgL: `./imgs/${name}/RAL3004.jpg`,
            color: '',
            backgroundPreview: 'rgb(107, 28, 35)',
        },
        {
            name: 'Синий',
            imgL: `./imgs/${name}/RAL5010.jpg`,
            color: '',
            backgroundPreview: 'rgb(0, 79, 124)',
        },
        {
            name: 'Зеленый мох',
            imgL: `./imgs/${name}/RAL6005.jpg`,
            color: '',
            backgroundPreview: 'rgb(17, 66, 50)',
        },
        {
            name: 'Серый антрацит',
            imgL: `./imgs/${name}/RAL7016.jpg`,
            color: '',
            backgroundPreview: 'rgb(56, 62, 66)',
        },
        {
            name: 'Коричневый',
            imgL: `./imgs/${name}/RAL8014.jpg`,
            color: '',
            backgroundPreview: 'rgb(74, 53, 38)',
        },
        {
            name: 'Шоколадный',
            imgL: `./imgs/${name}/RAL8017.jpg`,
            color: '',
            backgroundPreview: 'rgb(68, 47, 41)',
        },
        {
            name: 'Серебристый металлик',
            imgL: `./imgs/gofry/${name}.png`,
            color: 'rgb(161, 161, 160)',
            backgroundPreview: 'rgb(161, 161, 160)',
        },
        {
            name: 'Серо-алюминиевый',
            imgL: `./imgs/gofry/${name}.png`,
            color: 'rgb(135, 133, 129)',
            backgroundPreview: 'rgb(135, 133, 129)',
        },
        {
            name: 'Антрацит',
            imgL: `./imgs/${name}/703.jpg`,
            color: '',
            backgroundPreview: 'rgb(107, 107, 107)',
        },
    ]
}

function getTextureCifrovayaPechat(name) {
    return [
        {
            name: 'Розовое дерево',
            imgL: `./imgs/${name}/rosewood.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/rosewood_preview.jpg")'
        },
        {
            name: 'Махагон',
            imgL: `./imgs/${name}/mahagon.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/mahagon_preview.jpg")'
        },
        {
            name: 'Горная сосна',
            imgL: `./imgs/${name}/gorn_sosna.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/gorn_sosna_preview.jpg")'
        },
        {
            name: 'Орегон',
            imgL: `./imgs/${name}/oregon.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/oregon_preview.jpg")'
        },
        {
            name: 'Мореный дуб',
            imgL: `./imgs/${name}/moren_dub.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/moren_dub_preview.jpg")'
        },
        {
            name: 'Рустикальная вишня',
            imgL: `./imgs/${name}/rust_vishnya.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/rust_vishnya_preview.jpg")'
        },
        {
            name: 'Рустикальный дуб',
            imgL: `./imgs/${name}/rust_dub.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/rust_dub_preview.jpg")'
        },
        {
            name: 'Светлый дуб',
            imgL: `./imgs/${name}/light_dub.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/light_dub_preview.jpg")'
        },
        {
            name: 'Орех',
            imgL: `./imgs/${name}/orech.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/orech_preview.jpg")'
        },
        {
            name: 'Винчестер тёмный',
            imgL: `./imgs/${name}/vinch_dark.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/vinch_dark_preview.jpg")'
        },
        {
            name: 'Винчестер светлый',
            imgL: `./imgs/${name}/vinch_light.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/vinch_light_preview.jpg")'
        },
        {
            name: 'Антик',
            imgL: `./imgs/${name}/antik.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/antik_preview.jpg")'
        },
        {
            name: 'Белый дуб',
            imgL: `./imgs/${name}/white_dub.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/white_dub_preview.jpg")'
        },
        {
            name: 'Светлая сиена',
            imgL: `./imgs/${name}/svetl_siena.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/svetl_siena_preview.jpg")'
        },
        {
            name: 'Темная сиена',
            imgL: `./imgs/${name}/temn_siena.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/temn_siena_preview.jpg")'
        },
        {
            name: 'Бидасар браун',
            imgL: `./imgs/${name}/bisadar_braun.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/bisadar_braun_preview.jpg")'
        },
        {
            name: 'Бречия дамаската',
            imgL: `./imgs/${name}/brechia_damaskata.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/brechia_damaskata_preview.jpg")'
        },
        {
            name: 'Деликат голд',
            imgL: `./imgs/${name}/delicatus_gold.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/delicatus_gold.jpg")'
        },
        {
            name: 'Селебрити',
            imgL: `./imgs/${name}/selebriti.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/selebriti_preview.jpg")'
        },
        {
            name: 'Марун мариначе',
            imgL: `./imgs/${name}/marun_marinache.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/marun_marinache_preview.jpg")'
        },
        {
            name: 'Платина дарк',
            imgL: `./imgs/${name}/platina_dark.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/platina_dark_preview.jpg")'
        },
        {
            name: 'Гупарано бордо',
            imgL: `./imgs/${name}/guparano_bordo.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/guparano_bordo_preview.jpg")'
        },
        {
            name: 'Верде фантастико',
            imgL: `./imgs/${name}/verde_fantastiko.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/verde_fantastiko_preview.jpg")'
        },
        {
            name: 'Имперадор лайт',
            imgL: `./imgs/${name}/imperador_light.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/imperador_light_preview.jpg")'
        },
        {
            name: 'Имперадор дарк',
            imgL: `./imgs/${name}/imperador_dark.jpg`,
            color: '',
            backgroundPreview: 'url("./imgs/preview/imperador_dark_preview.jpg")'
        },

    ]
}
